import {SearchCustomersFilter} from './search-customers-filter';

export class SearchCustomersRequestBody {
  resultPartition?: number;
  searchFilter: SearchCustomersFilter;
  vehicleResultPartition?: number;
}
